import {Checkbox, Stack, Typography, useTheme} from '@mui/material';
import React from 'react';
import {DataInfo} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {translations} from 'presentation/translations-new';
import {useOdontoTermDrawer} from './hooks/useOdontoTermDrawer';
import {GeneralConditionsLink, StyledFormControlLabel} from './styles';

const {
	title,
	planLabel,
	ansRegisterLabel,
	declaration,
	acceptanceInfo,
	checkboxLabel,
	generalConditionsLink,
	acceptButton,
} = translations['pt-br'].privateFlow.home.odontoTermDrawer;
const {requiredField} = translations['pt-br'].commons;

export function OdontoTermDrawer() {
	const theme = useTheme();
	const {
		isOpen,
		isTermAgreed,
		hasTermAgreementError,
		isAcceptingTerm,
		generalConditionsUrl,
		planName,
		ansRegister,
		toggleTermAgreement,
		handleOpenGeneralConditions,
		handleClose,
		handleAccept,
	} = useOdontoTermDrawer();

	return (
		<Drawer.Root
			open={isOpen}
			onClose={() => null}
			onOpen={() => null}
			customMaxHeight="95%"
			width="520px"
			disableSwipeToOpen>
			<Drawer.Header title={title} onClose={handleClose} fontSize="1.125rem" />
			<Drawer.Content>
				<Stack gap={2}>
					<Stack>
						<DataInfo
							iconName="hapvida-logo"
							primaryText={planLabel}
							secondaryText={planName}
							primaryTextColor="text.secondary"
							primaryTextFontSize="0.875rem"
							secondaryTextFontSize="1rem"
							removeIconMargin
						/>
						<DataInfo
							iconName="assignment-filled"
							primaryText={ansRegisterLabel}
							secondaryText={ansRegister}
							primaryTextColor="text.secondary"
							primaryTextFontSize="0.875rem"
							secondaryTextFontSize="1rem"
							removePaddingBottom
							removeIconMargin
						/>
					</Stack>

					<Typography variant="body1">{declaration}</Typography>
					<Typography variant="body1">{acceptanceInfo}</Typography>
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				hideDivider
				hideFirstButton
				secondButtonTitle={acceptButton}
				secondButtonOnClick={handleAccept}
				secondButtonDisabled={isAcceptingTerm || !generalConditionsUrl}
				secondButtonIsLoading={isAcceptingTerm || !generalConditionsUrl}>
				<Stack direction="column" gap={1}>
					<StyledFormControlLabel
						control={
							<Checkbox
								checked={isTermAgreed}
								onChange={toggleTermAgreement}
								sx={{
									color: hasTermAgreementError ? theme.palette.error.main : null,
								}}
							/>
						}
						label={
							<Typography
								variant="body2"
								color={
									hasTermAgreementError
										? theme.palette.error.main
										: theme.palette.text.primary
								}>
								{`${checkboxLabel} `}
								<GeneralConditionsLink
									component="button"
									type="button"
									disabled={!generalConditionsUrl}
									onClick={event => {
										event.preventDefault();
										event.stopPropagation();
										handleOpenGeneralConditions();
									}}>
									{generalConditionsLink}
								</GeneralConditionsLink>
							</Typography>
						}
					/>
					{hasTermAgreementError ? (
						<Typography
							variant="caption"
							color={theme.palette.error.main}
							sx={{ml: 4, mt: -1}}>
							{requiredField}
						</Typography>
					) : null}
				</Stack>
			</Drawer.Footer>
		</Drawer.Root>
	);
}
